import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    container: {
        padding: '10px 0'        
    }
});